<template>
  <div id="app">
    <!-- <idcardValidate></idcardValidate> -->
    <validateCode></validateCode>
  </div>
</template>

<script>
// import idcardValidate from './components/id-card-validate.vue';
import validateCode from './components/validate-code.vue';

export default {
  name: 'App',
  components: {
    // idcardValidate,
    validateCode,
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #a9a5a5;
  overflow: hidden;
  background: url('./assets/bg2.jpg') no-repeat;
  background-size: cover;
}
</style>
